<template>
  <div class="content-item">
    <h2 class="heading">QR code</h2>
    <p class="text">
      Start by creating your QR code. We already started building the link for you we just need you to finish it with a name or acronym for your church. After you create the link a QR code will be
      generated and you can move on to your next step.
    </p>
    <div class="radio-group">
      <div class="row" style="justify-content: center">
        <a-row class="mt-2">
          <h4 class="text-center">Create your link that will be used on your invitation cards.</h4>
          <a-col class="slug-input-wrapper mt-2">
            <a-input
              :addon-before="urlPrefix"
              size="default"
              v-model="slug"
              pattern="^[a-z0-9]+(?:-[a-z0-9]+)*$"
              onkeypress="return event.charCode != 32"
              @keyup="onKeyUp"
              style="text-transform: lowercase"
              placeholder="Input your choice here"
            />
          </a-col>
          <a-col class="text-center mt-3">
            <a-button type="primary" class="action-button tf-btn tf-btn-primary" @click.prevent="onKeep">
              <span>Create</span>
            </a-button>
          </a-col>
        </a-row>
      </div>
    </div>
    <a-col v-if="db_slug" class="mt-4 text-center">
      <qrcode-vue :value="pageUrl" :size="150" render-as="svg" :margin="16" level="H" class="review-qr-code" />
    </a-col>
  </div>
</template>

<script>
import { get } from 'lodash';
import Constants from '@/constants.js';
import { checkValidSlug } from '@/utils';
import IntroVideoService from '@/services/IntroVideoService';
import QrcodeVue from 'qrcode.vue';
export default {
  name: 'Step1',
  components: {
    QrcodeVue,
  },
  props: {
    value: {
      type: Object,
    },
    source: {
      type: Object,
    },
  },
  computed: {
    frontCards() {
      return get(this.source, 'front', []);
    },
    urlPrefix() {
      return `${Constants.APP_URL}/invitation/`;
    },
    pageUrl() {
      return Constants.APP_URL + `/invitation/${this.db_slug}`;
    },
  },
  data() {
    return {
      selected: {},
      slug: null,
      db_slug: null,
      isLoading: false,
    };
  },
  async mounted() {
    await this.doInitData();
  },
  methods: {
    onDownloadQRCode() {
      import('@/utils/fileSaver').then(file => {
        file.saveImage(document.querySelector('.review-qr-code svg'), this.slug, 'svg');
      });
    },
    async doInitData() {
      try {
        this.isLoading = true;
        const resp = await IntroVideoService.fetch('welcome');
        if (resp) {
          this.db_slug = resp.slug;
          this.slug = resp.slug;
        }
      } catch (error) {
        console.log({ error });
      } finally {
        this.isLoading = false;
      }
    },
    onKeyUp(event) {
      this.slug = event.target.value.toLowerCase();
    },
    doSelectCard(card) {
      this.$emit('onSelectCard', card);
    },
    doSetCardSelected(card) {
      this.selected = card;
      setTimeout(() => {
        this.$emit('onNextPage');
      }, 500);
    },
    submit() {
      this.$emit('input', {
        ...this.value,
        card_front: this.selected.id,
      });
    },
    async onKeep() {
      if (!checkValidSlug(this.slug)) {
        this.$notification['warning']({
          message: 'You must only use lower case letters, no spaces or other characters are accepted.',
        });

        return false;
      }
      const isValid = await IntroVideoService.checkSlug('welcome', this.slug);
      if (!isValid) {
        this.$notification['warning']({
          message: 'This slug is already exist. Please use another slug.',
        });
        return false;
      }
      const res = await IntroVideoService.saveSlug('welcome', this.slug);
      if (res) {
        this.db_slug = res.slug;
        this.$notification['success']({
          message: 'QR code has been saved successfully!',
        });
      }
    },
  },
};
</script>
<style lang="scss" scoped>
@media (max-width: 767px) {
  .slug-input-wrapper {
    flex-direction: column;
    align-items: start;

    & > .slug-value {
      margin-left: 0;
    }
  }

  .video-container {
    display: block !important;
  }

  .sharethis-inline-share-buttons {
    margin-left: 0 !important;
    .st-btn:first {
      margin-left: 0 !important;
    }
  }
  .btn-order-start {
    margin-left: 0 !important;
  }

  .clipboard-btn {
    display: none;
  }

  .text-right {
    text-align: left !important;
  }

  .review-qr-code {
    svg {
      max-width: 150px !important;
      max-height: 150px !important;
    }
  }

  .qr-container {
    margin-top: 1rem;
  }
}
.review-qr-code {
  position: relative;

  svg {
    max-width: 300px;
    max-height: 300px;
  }
}
</style>
